import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { token, Text } from '@zillow/constellation';
import { getWholeDollars } from '../../../utils/zhl-calculator.js';

var StyledBudgetStretchedDescription = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-1y9fnn5-0"
})(["color:", ";"], token('colors.caution'));
var StyledBudgetComfortableDescription = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-1y9fnn5-1"
})(["color:", ";"], token('colors.green500'));
var StyledDescription = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1y9fnn5-2"
})(["text-align:center;"]);
var LiveRegion = /*#__PURE__*/styled(Text).attrs({
  'aria-live': 'polite',
  'aria-atomic': 'true',
  'fontType': 'h5'
}).withConfig({
  componentId: "sc-1y9fnn5-3"
})([""]);
var HomeValue = /*#__PURE__*/styled(Text).attrs({
  fontType: 'h3'
}).withConfig({
  componentId: "sc-1y9fnn5-4"
})(["display:block;"]);
var AffordabilityDescription = function AffordabilityDescription(_ref) {
  var aggressive = _ref.aggressive,
    customPayment = _ref.customPayment,
    affordabilityByDTI = _ref.affordabilityByDTI;
  return /*#__PURE__*/React.createElement(StyledDescription, null, /*#__PURE__*/React.createElement(LiveRegion, null, "You can afford a house up to", /*#__PURE__*/React.createElement(HomeValue, null, getWholeDollars(affordabilityByDTI))), /*#__PURE__*/React.createElement(Text, {
    fontType: "body"
  }, customPayment && /*#__PURE__*/React.createElement(React.Fragment, null, "A house at this price would keep you within your monthly payment budget. You could afford more with a bigger down payment."), aggressive && /*#__PURE__*/React.createElement(React.Fragment, null, "Based on your income, a house at this price", /*#__PURE__*/React.createElement("br", null), "may", ' ', /*#__PURE__*/React.createElement(StyledBudgetStretchedDescription, null, "stretch your budget"), ' ', "too thin."), !customPayment && !aggressive && /*#__PURE__*/React.createElement(React.Fragment, null, "Based on your income, a house at this price", /*#__PURE__*/React.createElement("br", null), "should", ' ', /*#__PURE__*/React.createElement(StyledBudgetComfortableDescription, null, "fit comfortably"), ' ', "within your budget.")));
};
AffordabilityDescription.propTypes = process.env.NODE_ENV !== "production" ? {
  aggressive: PropTypes.bool,
  customPayment: PropTypes.bool,
  affordabilityByDTI: PropTypes.number
} : {};
var AffordabilityDescription$1 = AffordabilityDescription;

export { AffordabilityDescription$1 as default };
